import React from 'react'
import { Tabs, Card, List, Button, Row, Col } from 'antd'
import {
  FlagPennant,
  Trophy,
  UserPlus,
  XCircle,
  BookmarkSimple,
  EnvelopeSimpleOpen,
  Funnel,
} from '@phosphor-icons/react'
import 'bootstrap/dist/css/bootstrap.min.css'
import styled from 'styled-components'
import { ScreenHeader } from 'components'
import { HeaderWrapper } from './dashboard'

const Container = styled.div`
  .ant-card-body {
    background: ${({ theme }) => theme.colors.background};
    padding: 10px;
  }
`
export const ActionButtons = styled.h5`
  font-size: 14px;
  padding: 10px;
  width: 100px;
  border: 1px solid #ddd;
  text-align: center;
  font-weight: normal;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.primary};
  &:hover {
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    cursor: pointer;
  }
`
const TimeText = styled.span`
  color: grey;
  font-size: 12px;
`
const TitleText = styled.span`
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 600;
`
const DescriptionText = styled.span`
  color: #1a1a1a;
`
const CustomHeading = styled.h5`
  font-size: 14px;
  color: #1a1a1a;
  border-bottom: 1px solid #ddd;
  display: block;
  padding-bottom: 2px;
`
const MarkAllRead = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #0b2ca1;
  }
`
const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background-color: white;
  border-radius: 50%;
`
const notifications = [
  {
    icon: (
      <IconWrapper>
        <FlagPennant size={32} color="#5C67CA" />
      </IconWrapper>
    ),
    title: 'Flagged Comment by Avin',
    description: 'Comment flagged on video: Test 1. Reason: No.',
    time: '10m ago',
  },
  {
    icon: (
      <IconWrapper>
        <Trophy size={32} color="#5C67CA" />
      </IconWrapper>
    ),
    title: 'Test 2 Deadline Approaching',
    description: 'Competition deadline is in 24 hours.',
    time: '1hr ago',
  },
  {
    icon: (
      <IconWrapper>
        <UserPlus size={32} color="#5C67CA" />
      </IconWrapper>
    ),
    title: 'New Entry for Test 3',
    description: 'Entry submitted by Jinga la la.',
    time: '5hr ago',
  },
  {
    icon: (
      <IconWrapper>
        <FlagPennant size={32} color="#5C67CA" />
      </IconWrapper>
    ),
    title: 'Flagged Comment by Nimesh',
    description: 'Comment flagged on video: Vie 3. Reason: Nai kevu le.',
    time: '12hr ago',
  },
]

const { TabPane } = Tabs
export const NotificationsScreen = () => {
  return (
    <>
      <div className="">
        <HeaderWrapper>
          <ScreenHeader text="notifications" />
          <ActionButtons>25 Unread</ActionButtons>
        </HeaderWrapper>
      </div>
      <div className="m-4">
        <Row justify="center">
          <Col span={24}>
            <div className="">
              <div className="tabs-container px-2">
                <Tabs defaultActiveKey="1" className="custom-tabs" centered>
                  <TabPane tab="All" key="1">
                    <div className="tab-content">
                      <div className="d-flex justify-content-between align-items-center ">
                        {/* Filter Button */}
                        <Button
                          type="default"
                          className="d-flex align-items-center"
                        >
                          <Funnel size={20} className="me-2" />
                          Filters
                        </Button>
                        <MarkAllRead>Mark all as read</MarkAllRead>
                      </div>

                      <Container className="container px-5 mt-5">
                        <CustomHeading>Today</CustomHeading>
                        <List
                          itemLayout="horizontal"
                          dataSource={notifications}
                          renderItem={item => (
                            <Card
                              className="mb-2 shadow-sm rounded-12 border-0"
                              style={{ backgroundColor: '#f8f9fa' }}
                            >
                              <List.Item
                                actions={[
                                  <Button
                                    type="text"
                                    icon={<XCircle size={24} />}
                                  />,
                                  <Button
                                    type="text"
                                    icon={<BookmarkSimple size={24} />}
                                  />,
                                  <Button
                                    type="text"
                                    icon={<EnvelopeSimpleOpen size={24} />}
                                  />,
                                ]}
                              >
                                <List.Item.Meta
                                  avatar={item.icon}
                                  title={
                                    <div className="d-flex align-items-center gap-1">
                                      <span>
                                        <TitleText>{item.title}</TitleText>
                                      </span>
                                      <TimeText>{item.time}</TimeText>
                                    </div>
                                  }
                                  description={
                                    <DescriptionText>
                                      {item.description}
                                    </DescriptionText>
                                  }
                                />
                              </List.Item>
                            </Card>
                          )}
                        />
                      </Container>
                    </div>
                  </TabPane>
                  <TabPane tab="Saved for Later" key="2">
                    <div className="tab-content">
                      This is the content for the Saved for Later tab.
                    </div>
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}
